export default __webpack_public_path__ + "2c7728f8073f88216a359a1f388ed3a4.svg";